import { warningNotification } from "./notications";

// Задължителен дневен модул "ЗБУТ".
// Модулът е твърдо зададен - няма динамичен избор.
export const ZBUT_MODULE_ID = 1;

export const ZBUT_MODULE_PATH = `/module?id=${ZBUT_MODULE_ID}`;
export const ZBUT_TEST_PATH = `/test?moduleId=${ZBUT_MODULE_ID}`;

// Заключеният служител се отваря директно в модула "ЗБУТ".
export const ZBUT_REDIRECT_PATH = ZBUT_MODULE_PATH;

// Плаващо съобщение, което изчезва само след 5 секунди.
// toastId пази от дублиране, докато съобщението още се вижда.
export const notifyZbutRequired = () =>
  warningNotification(
    'Задължително дневно попълване: попълнете теста по модул "ЗБУТ" за днес.',
    { autoClose: 5000, toastId: "zbut-daily" }
  );

// Страниците, достъпни докато служителят не е попълнил "ЗБУТ" за деня.
export const isZbutLocationAllowed = (pathname, search = "") => {
  const params = new URLSearchParams(search);

  switch (pathname) {
    case "/login":
    case "/my-courses":
    case "/forbidden-page":
      return true;
    case "/module":
      return Number(params.get("id")) === ZBUT_MODULE_ID;
    case "/test":
      return Number(params.get("moduleId")) === ZBUT_MODULE_ID;
    default:
      return false;
  }
};
